import axios from 'axios';

const BASE_URL = '/app/appointmentEventFunnel';

export const getAppointmentTypes = async () => {
    const { data } = await axios.get(`${BASE_URL}/appointmentTypes`);

    return data;
};
